import React from "react";

export default function TFJS_Visor() {
  return (
    <div>
      <h1>TFJS_Visor</h1>
      <p>This is the TFJS_Visor component.</p>
    </div>
  );
}
